export const OPTIONS = 'OPTIONS';
export const SETTINGS = 'SETTINGS';
export const FIELDS = 'FIELDS';
export const VISIBLE_FIELDS = 'VISIBLE_FIELDS';
export const ERRORS = 'ERRORS';
export const RESET = 'RESET';
export const UNSUBSCRIBE_FIELD = 'UNSUBSCRIBE_FIELD';
export const UNSUBSCRIBE_FIELD_OPTION = 'UNSUBSCRIBE_FIELD_OPTION';
